import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OkCancelModal from '../../shared/components/OkCancelModal';
import config from '../../config';
import api from '../../shared/api';
import messages from './documentMessages';
import ToastrService from '@/shared/services/ToastrService';
import Checkbox from '@/shared/components/input/Checkbox';
import handleHttpError from '@/shared/services/HandleHttpError';

export default class ProcessAuthorizationListModal extends Component {
  state = {
    createNewRelations: false,
    removeExpiredAuthorizations: false,
  };

  handleAuthorizationList = () => {
    const { createNewRelations, removeExpiredAuthorizations } = this.state;
    const { documentId, onSave, intl, stateService } = this.props;
    const model = {
      createNewRelations,
      removeExpiredAuthorizations,
      documentId,
    };
    return api.base
      .post(`${config.appUrls.api}/api/documentrecognition/HandleAuthorizationList`, model)
      .then(
        ({ data }) => {
          const onClick = data ? () => stateService.gotoJob(data.id) : undefined;
          ToastrService.info(
            intl.formatMessage(messages.ProcessAuthorizationListQueued),
            null,
            onClick,
          );
          onSave(data);
        },
        error => {
          handleHttpError(intl)(error);
        },
      );
  };

  render() {
    const { show, onClose, intl } = this.props;
    const { createNewRelations, removeExpiredAuthorizations } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ProcessAuthorizationList)}
        show={show}
        onClose={onClose}
        onSave={() => this.handleAuthorizationList()}
      >
        <div className="row">
          <div className="form-horizontal">
            <div className="form-group">
              <div className="col-sm-11 col-sm-offset-1">
                <Checkbox
                  value={createNewRelations}
                  text={intl.formatMessage(messages.CreateNewRelations)}
                  onClick={value =>
                    this.setState({
                      createNewRelations: value,
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-11 col-sm-offset-1">
                <Checkbox
                  value={removeExpiredAuthorizations}
                  text={intl.formatMessage(messages.RemoveExpiredAuthorizations)}
                  onClick={value =>
                    this.setState({
                      removeExpiredAuthorizations: value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
